import RoleForm from '../components/Form'
import useModalForm from '../../../@hooks/useModalForm'
import Service from '../../../@services/user'

export default function useModifierRoleDialog(cb) {
  const { open } = useModalForm(RoleForm)

  const openDialog = id => {
    return open(
      async req => {
        const res = await Service.update(req)
        if (typeof cb === 'function') {
          cb(res)
        }
      },
      async () => {
        const res = (await Service.getDetail(id)) || {}
        return {
          id: res.id,
          username: res.username,
          name: res.name,
          password: res.initPassword,
          roles: res.roles || [],
          stores: res.stores || [],
          remark: res.remark,
          status: res.status,
          type: res.type,
          createdAt: res.createdAt,
        }
      },
      {
        title: '修改用户',
      }
    )
  }

  return openDialog
}
